// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.appointments-new-drawer .patient-appointment-drawer__footer {
  justify-content: flex-end;
}

.appointments-new__section {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  background: #ffffff;
}

.appointments-new__section h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: -0.005em;
  color: #0f172a;
}

.appointments-new__section-hint {
  margin: 2px 0 0;
  font-size: 12px;
  line-height: 1.4;
  color: #64748b;
}

.appointments-new__search {
  display: flex;
  gap: 8px;
  align-items: center;
}

.appointments-new__search .patient-appointment-drawer__control {
  flex: 1;
  min-width: 0;
}

.appointments-new__phone.ant-input {
  height: 36px;
  border-radius: 8px;
  border-color: #e2e8f0;
  padding-inline-start: 36px;
  font-size: 12px;
  font-variant-numeric: tabular-nums;
  box-shadow: none;
}

.appointments-new__phone.ant-input:focus {
  border-color: #0ea5e9;
  box-shadow: 0 0 0 2px rgba(14, 165, 233, 0.2);
}

.appointments-new__status,
.appointments-new__empty {
  margin: 0;
  font-size: 12px;
  color: #64748b;
}

.appointments-new__results {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.appointments-new__patient {
  box-sizing: border-box;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  background: #ffffff;
  text-align: start;
  font-family: inherit;
  cursor: pointer;
}

.appointments-new__patient.is-selected {
  border-color: #0ea5e9;
  background: #f0f9ff;
}

.appointments-new__patient-main {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.appointments-new__avatar {
  width: 40px;
  height: 40px;
  border-radius: 999px;
  background: #e0f2fe;
  color: #0284c7;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 700;
  flex-shrink: 0;
}

.appointments-new__patient-copy {
  min-width: 0;
}

.appointments-new__patient-name {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  font-size: 14px;
  font-weight: 600;
  color: #0f172a;
}

.appointments-new__code {
  display: inline-flex;
  align-items: center;
  height: 20px;
  padding: 0 8px;
  border-radius: 999px;
  background: #e0f2fe;
  color: #0284c7;
  font-size: 11px;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
}

.appointments-new__phone-line {
  margin-top: 2px;
  font-size: 12px;
  color: #64748b;
  font-variant-numeric: tabular-nums;
}

.appointments-new__selected {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
  height: 28px;
  padding: 0 10px;
  border-radius: 8px;
  background: #0ea5e9;
  color: #ffffff;
  font-size: 12px;
  font-weight: 600;
}

@media (max-width: 520px) {
  .appointments-new__search {
    flex-direction: column;
    align-items: stretch;
  }

  .appointments-new__search .patient-appointment-drawer__btn {
    width: 100%;
  }

  .appointments-new__patient {
    align-items: flex-start;
    flex-direction: column;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Appointments/NewAppointmentDrawer.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,0BAA0B;EAC1B,eAAe;EACf,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;;EAEE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;EACxB;AACF","sourcesContent":[".appointments-new-drawer .patient-appointment-drawer__footer {\n  justify-content: flex-end;\n}\n\n.appointments-new__section {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 16px;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  background: #ffffff;\n}\n\n.appointments-new__section h3 {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: -0.005em;\n  color: #0f172a;\n}\n\n.appointments-new__section-hint {\n  margin: 2px 0 0;\n  font-size: 12px;\n  line-height: 1.4;\n  color: #64748b;\n}\n\n.appointments-new__search {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n\n.appointments-new__search .patient-appointment-drawer__control {\n  flex: 1;\n  min-width: 0;\n}\n\n.appointments-new__phone.ant-input {\n  height: 36px;\n  border-radius: 8px;\n  border-color: #e2e8f0;\n  padding-inline-start: 36px;\n  font-size: 12px;\n  font-variant-numeric: tabular-nums;\n  box-shadow: none;\n}\n\n.appointments-new__phone.ant-input:focus {\n  border-color: #0ea5e9;\n  box-shadow: 0 0 0 2px rgba(14, 165, 233, 0.2);\n}\n\n.appointments-new__status,\n.appointments-new__empty {\n  margin: 0;\n  font-size: 12px;\n  color: #64748b;\n}\n\n.appointments-new__results {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.appointments-new__patient {\n  box-sizing: border-box;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 12px;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  background: #ffffff;\n  text-align: start;\n  font-family: inherit;\n  cursor: pointer;\n}\n\n.appointments-new__patient.is-selected {\n  border-color: #0ea5e9;\n  background: #f0f9ff;\n}\n\n.appointments-new__patient-main {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  min-width: 0;\n}\n\n.appointments-new__avatar {\n  width: 40px;\n  height: 40px;\n  border-radius: 999px;\n  background: #e0f2fe;\n  color: #0284c7;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 13px;\n  font-weight: 700;\n  flex-shrink: 0;\n}\n\n.appointments-new__patient-copy {\n  min-width: 0;\n}\n\n.appointments-new__patient-name {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 6px;\n  font-size: 14px;\n  font-weight: 600;\n  color: #0f172a;\n}\n\n.appointments-new__code {\n  display: inline-flex;\n  align-items: center;\n  height: 20px;\n  padding: 0 8px;\n  border-radius: 999px;\n  background: #e0f2fe;\n  color: #0284c7;\n  font-size: 11px;\n  font-weight: 600;\n  font-variant-numeric: tabular-nums;\n}\n\n.appointments-new__phone-line {\n  margin-top: 2px;\n  font-size: 12px;\n  color: #64748b;\n  font-variant-numeric: tabular-nums;\n}\n\n.appointments-new__selected {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  flex-shrink: 0;\n  height: 28px;\n  padding: 0 10px;\n  border-radius: 8px;\n  background: #0ea5e9;\n  color: #ffffff;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n@media (max-width: 520px) {\n  .appointments-new__search {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .appointments-new__search .patient-appointment-drawer__btn {\n    width: 100%;\n  }\n\n  .appointments-new__patient {\n    align-items: flex-start;\n    flex-direction: column;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
